module.exports = __webpack_public_path__ + "img/PXL_20230524_174747457.56c726bc.jpg";